import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDiagnosticosOms } from "../../../../../redux/actions/denuncia";
import HeaderForm from "../../../../commons/labels/HeaderForm";
import AccidenteTable from "../../commons/AccidenteTable";

const DiagnosticoAccidenteContainer = ({ handleSubmitAllForm }) => {
  const dispatch = useDispatch();

  const datosDenuncia = useSelector((state) => state.denuncia.postDenuncia);

  useEffect(() => {
    if (
      datosDenuncia.datosDenuncia &&
      datosDenuncia.datosDenuncia.tipoSiniestro
    ) {
      dispatch(getDiagnosticosOms(datosDenuncia.datosDenuncia.tipoSiniestro));
    }
  }, []);

  return (
    <>
      <HeaderForm title="Diagnóstico de Accidente" />
      <AccidenteTable
        handleSubmit={handleSubmitAllForm}
        data={datosDenuncia.diagnosticoAccidente}
      />
    </>
  );
};

export default DiagnosticoAccidenteContainer;
